export default class ConsoleLogEntry {
  constructor(type, args) {
    this.type = type;
    this.timestamp = new Date().toISOString();
    this.message = this._formatMessage(args);
  }

  _formatMessage(args) {
    return args
      .map(a =>
        typeof a === 'undefined'
          ? '[undefined]'
          : typeof a === 'object'
            ? JSON.stringify(a, null, 2)
            : String(a)
      )
      .join(' ');
  }

  toJSON() {
    return {
      type: this.type,
      timestamp: this.timestamp,
      message: this.message
    };
  }

  toFirestore() {
    return {
      type: this.type || null,
      timestamp: this.timestamp || null,
      message: this.message || null
    };
  }
}
